import { render, staticRenderFns } from "./CustomerView.vue?vue&type=template&id=3089b5ff&scoped=true&"
import script from "./CustomerView.vue?vue&type=script&lang=js&"
export * from "./CustomerView.vue?vue&type=script&lang=js&"
import style0 from "./CustomerView.vue?vue&type=style&index=0&id=3089b5ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3089b5ff",
  null
  
)

export default component.exports